<div class="ms" *ngIf="!compact">
  <div class="ms__bar">
    <div class="ms__textarea-wrap">
      <textarea
        class="ms__textarea"
        [class.ms__textarea--hidden]="isListening"
        [readonly]="isListening"
        [attr.aria-hidden]="isListening ? 'true' : null"
        [rows]="commonService.isMobileDisableClick ? 2 : (lyricsOpen ? 1 : 2)"
        [(ngModel)]="queryText"
        (ngModelChange)="onQueryChange($event)"
        (keydown)="onEnter($event)">
      </textarea>
      <span class="ms__placeholder" *ngIf="!queryText && !isListening" [class.ms__placeholder--fade]="placeholderFading">
        {{ currentPlaceholder }}
      </span>
      <!-- Voice waveform overlay shown while listening -->
      <div class="ms__voice-wave" *ngIf="isListening">
        <span *ngFor="let h of voiceBars; trackBy: trackByIndex" class="ms__voice-wave-bar" [style.height.%]="h * 100"></span>
      </div>
    </div>

    <div *ngIf="audio" class="ms__chip">
      <button class="ms__chip-play" *ngIf="audioUrl" (click)="togglePlayAudio()" [title]="isPlaying ? 'Pause' : 'Play'">
        <i class="fa fa-play" *ngIf="!isPlaying"></i>
        <i class="fas fa-pause" *ngIf="isPlaying"></i>
      </button>
      <div class="ms__chip-wave" *ngIf="audioUrl">
        <span *ngFor="let h of chipBars; let i = index; trackBy: trackByIndex"
          class="ms__chip-wave-bar"
          [class.ms__chip-wave-bar--played]="isPlaying && i < playedBarCount"
          [style.height.%]="h">
        </span>
        <!-- <div class="ms__chip-wave-progress" [style.width.%]="playbackProgress"></div> -->
      </div>
      <span class="ms__chip-name">{{ audio.name }}</span>
      <button (click)="removeAudio()">✕</button>
    </div>

    <div *ngIf="lyricsOpen" class="ms__lyrics">
      <div class="ms__lyrics-header"><img src="assets/imgs/magic-search/ms-lyrics-icon.svg" width="13" height="9" alt=""> Lyrics</div>
      <textarea rows="3" placeholder="Paste or type lyrics…" [(ngModel)]="lyricsText"></textarea>
    </div>

    <div class="ms__bar-actions">
      <div class="ms__bar-left">
        <button class="ms-btn-ghost" [class.ms-btn-ghost--active]="lyricsOpen" (click)="toggleLyrics()" *ngIf="!commonService.isMobileDisableClick"><img src="assets/imgs/magic-search/ms-lyrics-icon.svg" alt="lyrics"> Lyrics</button>

        <button
          class="ms__attach-trigger"
          [class.ms__attach-trigger--active]="attachTrigger.menuOpen"
          #attachTrigger="matMenuTrigger"
          [matMenuTriggerFor]="attachMenu"
          type="button"
          title="Add audio" aria-label="Add audio">
          <span class="ms__attach-plus">+</span>
        </button>
      </div>
      <div class="ms__bar-right">
        <div class="ms__mic-controls" *ngIf="isListening">
          <!-- <button class="ms-microphone" (click)="isPaused ? resumeSpeech() : pauseSpeech()" [title]="isPaused ? 'Resume' : 'Pause'">
            <i class="fas" [class.fa-play]="isPaused" [class.fa-pause]="!isPaused"></i>
          </button> -->
          <!-- <button class="ms-microphone" (click)="stopSpeech()" title="Stop">
            <span class="pi pi-stop-circle"></span>
          </button> -->
        </div>
        <!-- <button *ngIf="!isListening" class="ms-microphone" (click)="startSpeechSearch()" title="Voice search">
          <img src="assets/imgs/magic-search/mic.svg" alt="mic">
        </button> -->
        <!-- <button class="ms-btn-ghost" (click)="reset()">Reset</button> -->
        <button class="ms-btn ms-btn--search" [disabled]="isListening" (click)="runSearch()"> <span class="pi pi-search" ></span> Search</button>
      </div>
    </div>
  </div>
</div>

<!-- Compact bar: single icon+input row, embedded inside FilterSectionComponent's search
     wrapper on the beats-list page. All logic above (speech, audio, lyrics, filters) is
     shared as-is — only the visual shell differs. -->
<div class="ms ms--compact" *ngIf="compact">
  <button
    class="ms__attach-trigger ms__compact-icon"
    [class.ms__attach-trigger--active]="attachTrigger.menuOpen"
    #attachTrigger="matMenuTrigger"
    [matMenuTriggerFor]="attachMenu"
    type="button"
    title="Add lyrics or audio">
    <span class="ms__attach-plus">+</span>
  </button>
  <input
    type="search"
    class="ms__compact-input"
    placeholder="Describe your sound..."
    [(ngModel)]="queryText"
    [ngModelOptions]="{standalone: true}"
    (ngModelChange)="onQueryChange($event)"
    (keyup.enter)="runSearch()"
    (search)="runSearch()"
    (blur)="runSearch()">
</div>

<mat-menu #attachMenu="matMenu" [class]="'ipm-custom-menu ms-attach-menu'" xPosition="after" yPosition="below" [overlapTrigger]="false">
  <button mat-menu-item *ngIf="compact" (click)="openLyricsModal()">
    <img src="assets/imgs/magic-search/ms-lyrics-icon.svg" alt=""> <span>Add Lyrics</span>
  </button>
  <button mat-menu-item *ngIf="!compact && commonService.isMobileDisableClick" (click)="toggleLyrics()">
    <img src="assets/imgs/magic-search/ms-lyrics-icon.svg" alt=""> <span>Lyrics</span>
  </button>
  <button mat-menu-item (click)="selectAttachOption('record')">
    <img src="assets/imgs/magic-search/mic.svg" alt=""> <span>Record Vocals</span>
  </button>
  <button mat-menu-item (click)="selectAttachOption('upload')">
    <img src="assets/imgs/magic-search/music.svg" alt=""> <span>Match this Audio</span>
  </button>
</mat-menu>

<ng-template #audioDialog let-data>
  <ipm-magic-search-audio-modal [fingerprint]="data?.fingerprint"  [activeTab]="data?.activetab" ></ipm-magic-search-audio-modal>
</ng-template>

<ng-template #lyricsDialog>
  <div class="ms-lyrics-modal">
    <div class="ms-lyrics-modal__header">
      <span class="ms-lyrics-modal__title"><img src="assets/imgs/magic-search/ms-lyrics-icon.svg" width="14" height="10" alt=""> Lyrics</span>
      <button type="button" class="ms-lyrics-modal__close" (click)="commonService.closePopUp()" aria-label="Close">✕</button>
    </div>
    <textarea
      class="ms-lyrics-modal__textarea"
      rows="8"
      placeholder="Paste or type lyrics…"
      [(ngModel)]="lyricsDraftText"
      [ngModelOptions]="{standalone: true}"
      autofocus>
    </textarea>
    <div class="ms-lyrics-modal__footer">
      <button type="button" class="ms-btn ms-lyrics-modal__remove" *ngIf="lyricsOpen" (click)="removeLyricsModal()">Remove</button>
      <button type="button" class="ms-btn ms-btn--search ms-lyrics-modal__save" (click)="saveLyricsModal()">Save</button>
    </div>
  </div>
</ng-template>
